module.exports = __webpack_public_path__ + "static/media/Printer.02d82fb4.png";